<template>
  <div>
    <div class="runter_bg_box clearfix_">
      <div :class="{runter_bg_active:step>=1}" class="fl runter_bg1"><span :class="{span_active:step>=1}">1</span>买家申请退货</div>
      <div class="fl">
        <img v-show="step==1" :src="runter_bg1" alt="">
        <img v-show="step>1" :src="runter_bg3" alt="">
      </div>
      <div :class="{runter_bg_active:step>=2}" class="fl runter_bg1"><span :class="{span_active:step>=2}">2</span>{{canceTxt?canceTxt:'等待卖家处理'}}</div>
      <div class="fl">
        <img v-show="step==2" :src="runter_bg1" alt="">
        <img v-show="step<2" :src="runter_bg2" alt="">
        <img v-show="step>2" :src="runter_bg3" alt="">
      </div>
      <div :class="{runter_bg_active:step>=3}" class="fl runter_bg1"><span :class="{span_active:step>=3}">3</span>卖家处理结果</div>
      <div class="fl">
        <img v-show="step==3" :src="runter_bg1" alt="">
        <img v-show="step<3" :src="runter_bg2" alt="">
        <img v-show="step>3" :src="runter_bg3" alt="">
      </div>
      <div :class="{runter_bg_active:step>=4}" class="fl runter_bg1"><span :class="{span_active:step>=4}">4</span>退货成功</div>
    </div>
    <div class="runter_goods_box clearfix_">
      <div v-show="step==1" class="fl runter_goods_box_runter">
        <div v-show="!totalReturn" class="clearfix_">
          <div style="margin-top:20px;" class="fl runter_title">退款商品：</div>
          <div class="fl clearfix_ runter_shopp">
            <div class="fl runter_shopp_pic"><img :src="goodsData.pic" alt=""></div>
            <div class="fl runter_shopp_name"><p>{{goodsData.goodsName}}</p><p>{{goodsData.goodsUnitName}} {{goodsData.property1}}</p></div>
          </div>
        </div>
        <div class="clearfix_">
          <div style="line-height:40px;" class="fl runter_title">退款原因：</div>
          <div>
            <el-select style="width:142px;margin-right:30px;" v-model="cause" placeholder="请选择">
              <el-option label="退运费" value="1"> </el-option>
              <el-option label="收到商品破损" value="2"> </el-option>
              <el-option label="商品发错，漏发" value="3"> </el-option>
              <el-option label="商品需要维修" value="4"> </el-option>
              <el-option label="发票问题" value="5"> </el-option>
              <el-option label="收到商品不符" value="6"> </el-option>
              <el-option label="商品质量问题" value="7"> </el-option>
              <el-option label="未收到货" value="8"> </el-option>
              <el-option label="未按约定时间发货" value="9"> </el-option>
              <el-option label="其他" value="10"> </el-option>
            </el-select>
          </div>
        </div>
         <div v-show="returnType!=-1" class="clearfix_">
          <div style="line-height:40px;" class="fl runter_title">退货方式：</div>
          <div>
            <el-select :disabled="returnType?true:false" style="width:142px;margin-right:30px;" v-model="returnGoodsMode" placeholder="请选择">
              <el-option label="上门取货" value="1"> </el-option>
              <el-option label="自助退货" value="2"> </el-option>
            </el-select>
          </div>
        </div> 
        <div v-show="!totalReturn" class="clearfix_">
          <div style="line-height:25px;" class="fl runter_title">退款数量：</div>
          <div class="addanredueBox fl">
            <button @click="ChangeNum(-1)" :disabled="num<=1">-</button>
            <input @blur="ChangeNum(0)" type="number" autocomplete="off" onkeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))" style="ime-mode:Disabled" v-model="num"/>
            <button @click="ChangeNum(1)" :disabled="num>=goodsData.num">+</button>
          </div>
        </div>
        <div class="clearfix_">
          <div style="margin-top:20px;" class="fl runter_title">退款说明：</div>
          <div class="fl runter_text"><textarea v-model="msg" maxlength="200"></textarea></div>
        </div>
        <div class="clearfix_">
          <div style="margin-top:5px;" class="fl runter_title">上传图片：</div>
          <ul class="runter_upload fl clearfix_">
            <li class="fl" v-for="(item,index) in upLoadList" :key="index"><img :src="item" alt=""></li>
            <li v-show="upLoadList.length<5" class="add_box fl">
              <p><img :src="addImg" alt=""></p>
              <p>上传凭证</p>
              <p>（最多5张）</p>
              <input class="file img_btn" multiple type="file" accept="image/png,image/gif,image/jpeg" @change="uploadImgFn($event)"/>
            </li>
          </ul>
        </div>
        <div v-show="!totalReturn" class="runter_goods_btn"><span @click="submit">提交</span></div>
        <div v-show="totalReturn" class="runter_goods_btn"><span @click="submitForOrder">提交</span></div>
      </div>
      <div v-show="step==2" class="fl runter_goods_box_runter">
        <div v-show="waitData.status==1">
          <div class="runter_step2_title">
            <div class="txt1">等待卖家处理</div>
          </div>
          <div class="runter_step2_txt">
            <div class="">
              <div style="margin-bottom:10px;">您已成功发起退款申请,请耐心等待商家处理</div>
              <div style="margin-bottom:10px;">· 商家同意或者超时未处理，系统将退款给您</div>
              <div style="margin-bottom:10px;">· 如果商家拒绝，您可以修改退款申请后再次发起，商家会重新处理</div>
            </div>
            <div class="txt1">退货清单</div>
            <div class="txt1 clearfix_">
              <div>
                <div class="order_goods_information">
                  <p class="order_goods_title">商品信息</p>
                  <div class="order_goods_explain clearfix_">
                    <div class="fl goodsName">商品名称</div>
                    <div class="fl price">单价</div>
                    <div class="fl num">数量</div>
                    <div class="fl operation">商品操作</div>
                  </div>
                </div>
                <ul class="order_goods_information_ul">
                  <li  v-for="(item,index) in waitData.goodsData" :key="index" class="clearfix_">
                    <img class="fl" :src="item.pic?item.pic:timg" alt="">
                    <div class="goodsName fl"><p>{{item.goodsName}}</p><p>{{item.goodsUnitName}} {{item.property1}}</p></div>
                    <div class="price fl">¥{{item.salesMoney}}</div>
                    <div class="num fl">{{item.num}}</div>
                    <div class="operation fl clearfix_">
                      <span @click="cancelReturnForGoods(item.id)" class="fl">取消申请</span>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div v-show="waitData.giftData!==undefined&&waitData.giftData!==null&&waitData.giftData.length>0" class="txt1 clearfix_">
              <div class="fl txt1_name">赠品：</div> 
              <div class="fl txt1_goods">
                <div v-for="(item,index) in waitData.giftData" :key="index" class="txt1_goods_item clearfix_">
                  <div class="txt1_goods_item_name fl">{{item.goodsName}}</div>
                  <div class="txt1_goods_item_txt fl">{{item.goodsUnitName}} {{item.property1}} *{{item.num}}</div>
                </div>
              </div>
            </div>
            <div v-show="waitData.couponData!==undefined&&waitData.couponData!==null&&waitData.couponData.length>0" class="txt1 clearfix_">
              <div class="fl txt1_name">优惠券：</div>
              <div class="fl txt1_goods">
                <div v-for="(item,index) in waitData.couponData" :key="index" class="txt1_goods_item clearfix_">
                  <div class="txt1_goods_item_name fl">{{item.couponRuleName}}</div>
                  <div class="txt1_goods_item_txt fl">¥{{item.money}} *{{item.couponNum}}</div>
                </div>
              </div>
            </div>
            <div v-show="parseInt(waitData.couponReturnMoney)" class="txt1 clearfix_">
              <div class="fl txt1_name">优惠券扣款：</div>
              <div class="fl txt1_txt">{{waitData.couponReturnMoney}}</div>
            </div>
            <div v-show="waitData.score" class="txt1 clearfix_">
              <div class="fl txt1_name">积分：</div>
              <div class="fl txt1_txt">{{waitData.score}}</div>
            </div>
            <div v-show="parseInt(waitData.postageMoney)" class="txt1 clearfix_">
              <div class="fl txt1_name">运费：</div>
              <div class="fl txt1_txt">{{waitData.postageMoney}}</div>
            </div>
            <div class="txt1 clearfix_">
              <div style="margin-top:2px;" class="fl txt1_name">退款金额：</div>
              <div class="fl txt1_txt"><span>¥{{waitData.totalAmount}}</span></div>
            </div>
          </div>
          <div style="text-align:right;" class="runter_goods_btn"><span @click="cancelReturnForOrder">全部取消</span></div>
        </div>
        <div v-show="waitData.status==4">
          <div class="runter_step2_title">
            <div class="txt1">买家已取消</div>
          </div>
          <div class="runter_step2_txt">
            <div class="txt1">退货清单</div>
            <div class="txt1 clearfix_">
              <div>
                <div class="order_goods_information">
                  <p class="order_goods_title">商品信息</p>
                  <div class="order_goods_explain clearfix_">
                    <div class="fl goodsName">商品名称</div>
                    <div class="fl price">单价</div>
                    <div class="fl num">数量</div>
                    <div class="fl operation">商品操作</div>
                  </div>
                </div>
                <ul class="order_goods_information_ul">
                  <li  v-for="(item,index) in waitData.goodsData" :key="index" class="clearfix_">
                    <img class="fl" :src="item.pic?item.pic:timg" alt="">
                    <div class="goodsName fl"><p>{{item.goodsName}}</p><p>{{item.goodsUnitName}} {{item.property1}}</p></div>
                    <div class="price fl">¥{{item.salesMoney}}</div>
                    <div class="num fl">{{item.num}}</div>
                  </li>
                </ul>
              </div>
            </div>
            <div v-show="waitData.giftData!==undefined&&waitData.giftData!==null&&waitData.giftData.length>0" class="txt1 clearfix_">
              <div class="fl txt1_name">赠品：</div> 
              <div class="fl txt1_goods">
                <div v-for="(item,index) in waitData.giftData" :key="index" class="txt1_goods_item clearfix_">
                  <div class="txt1_goods_item_name fl">{{item.goodsName}}</div>
                  <div class="txt1_goods_item_txt fl">{{item.goodsUnitName}} {{item.property1}} *{{item.num}}</div>
                </div>
              </div>
            </div>
            <div v-show="waitData.couponData!==undefined&&waitData.couponData!==null&&waitData.couponData.length>0" class="txt1 clearfix_">
              <div class="fl txt1_name">优惠券：</div>
              <div class="fl txt1_goods">
                <div v-for="(item,index) in waitData.couponData" :key="index" class="txt1_goods_item clearfix_">
                  <div class="txt1_goods_item_name fl">{{item.couponRuleName}}</div>
                  <div class="txt1_goods_item_txt fl">¥{{item.money}} *{{item.couponNum}}</div>
                </div>
              </div>
            </div>
            <div v-show="parseInt(waitData.couponReturnMoney)" class="txt1 clearfix_">
              <div class="fl txt1_name">优惠券扣款：</div>
              <div class="fl txt1_txt">{{waitData.couponReturnMoney}}</div>
            </div>
            <div v-show="waitData.score" class="txt1 clearfix_">
              <div class="fl txt1_name">积分：</div>
              <div class="fl txt1_txt">{{waitData.score}}</div>
            </div>
            <div v-show="parseInt(waitData.postageMoney)" class="txt1 clearfix_">
              <div class="fl txt1_name">运费：</div>
              <div class="fl txt1_txt">{{waitData.postageMoney}}</div>
            </div>
            <div class="txt1 clearfix_">
              <div style="margin-top:2px;" class="fl txt1_name">退款金额：</div>
              <div class="fl txt1_txt"><span>¥{{waitData.totalAmount}}</span></div>
            </div>
          </div>
        </div>
      </div>
      <div v-show="step==3&&waitData.status==3" class="fl runter_goods_box_runter">
        <div class="runter_step2_title">
          <div class="txt1">卖家已拒绝</div>
        </div>
        <div class="runter_step2_txt">
          <div class="txt1">拒绝原因：<span style="color:#333;">{{waitData.refusedRemark}}</span></div>
          <div class="txt1">退货清单</div>
          <div class="txt1 clearfix_">
            <div>
              <div class="order_goods_information">
                <p class="order_goods_title">商品信息</p>
                <div class="order_goods_explain clearfix_">
                  <div class="fl goodsName">商品名称</div>
                  <div class="fl price">单价</div>
                  <div class="fl num">数量</div>
                  <div class="fl operation">商品操作</div>
                </div>
              </div>
              <ul class="order_goods_information_ul">
                <li  v-for="(item,index) in waitData.goodsData" :key="index" class="clearfix_">
                  <img class="fl" :src="item.pic?item.pic:timg" alt="">
                  <div class="goodsName fl"><p>{{item.goodsName}}</p><p>{{item.goodsUnitName}} {{item.property1}}</p></div>
                  <div class="price fl">¥{{item.salesMoney}}</div>
                  <div class="num fl">{{item.num}}</div>
                </li>
              </ul>
            </div>
          </div>
          <div v-show="waitData.giftData!==undefined&&waitData.giftData!==null&&waitData.giftData.length>0" class="txt1 clearfix_">
            <div class="fl txt1_name">赠品：</div> 
            <div class="fl txt1_goods">
              <div v-for="(item,index) in waitData.giftData" :key="index" class="txt1_goods_item clearfix_">
                <div class="txt1_goods_item_name fl">{{item.goodsName}}</div>
                <div class="txt1_goods_item_txt fl">{{item.goodsUnitName}} {{item.property1}} *{{item.num}}</div>
              </div>
            </div>
          </div>
          <div v-show="waitData.couponData!==undefined&&waitData.couponData!==null&&waitData.couponData.length>0" class="txt1 clearfix_">
            <div class="fl txt1_name">优惠券：</div>
            <div class="fl txt1_goods">
              <div v-for="(item,index) in waitData.couponData" :key="index" class="txt1_goods_item clearfix_">
                <div class="txt1_goods_item_name fl">{{item.couponRuleName}}</div>
                <div class="txt1_goods_item_txt fl">¥{{item.money}} *{{item.couponNum}}</div>
              </div>
            </div>
          </div>
          <div v-show="parseInt(waitData.couponReturnMoney)" class="txt1 clearfix_">
            <div class="fl txt1_name">优惠券扣款：</div>
            <div class="fl txt1_txt">{{waitData.couponReturnMoney}}</div>
          </div>
          <div v-show="waitData.score" class="txt1 clearfix_">
            <div class="fl txt1_name">积分：</div>
            <div class="fl txt1_txt">{{waitData.score}}</div>
          </div>
          <div v-show="parseInt(waitData.postageMoney)" class="txt1 clearfix_">
            <div class="fl txt1_name">运费：</div>
            <div class="fl txt1_txt">{{waitData.postageMoney}}</div>
          </div>
          <div class="txt1 clearfix_">
            <div style="margin-top:2px;" class="fl txt1_name">退款金额：</div>
            <div class="fl txt1_txt"><span>¥{{waitData.totalAmount}}</span></div>
          </div>
        </div>
      </div>
      <div v-show="step==3&&waitData.status==2" class="fl runter_goods_box_runter">
        <div class="runter_step2_title">
          <div class="txt1">卖家已同意</div>
        </div>
        <div class="runter_step2_txt">
          <div class="txt1">{{addressInfo.recipient}} {{addressInfo.mobilePhone}} {{addressInfo.address}}</div>
          <div class="txt1">退货清单</div>
          <div class="txt1 clearfix_">
            <div>
              <div class="order_goods_information">
                <p class="order_goods_title">商品信息</p>
                <div class="order_goods_explain clearfix_">
                  <div class="fl goodsName">商品名称</div>
                  <div class="fl price">单价</div>
                  <div class="fl num">数量</div>
                  <div class="fl operation">商品操作</div>
                </div>
              </div>
              <ul class="order_goods_information_ul">
                <li  v-for="(item,index) in waitData.goodsData" :key="index" class="clearfix_">
                  <img class="fl" :src="item.pic?item.pic:timg" alt="">
                  <div class="goodsName fl"><p>{{item.goodsName}}</p><p>{{item.goodsUnitName}} {{item.property1}}</p></div>
                  <div class="price fl">¥{{item.salesMoney}}</div>
                  <div class="num fl">{{item.num}}</div>
                </li>
              </ul>
            </div>
          </div>
          <div v-show="waitData.giftData!==undefined&&waitData.giftData!==null&&waitData.giftData.length>0" class="txt1 clearfix_">
            <div class="fl txt1_name">赠品：</div> 
            <div class="fl txt1_goods">
              <div v-for="(item,index) in waitData.giftData" :key="index" class="txt1_goods_item clearfix_">
                <div class="txt1_goods_item_name fl">{{item.goodsName}}</div>
                <div class="txt1_goods_item_txt fl">{{item.goodsUnitName}} {{item.property1}} *{{item.num}}</div>
              </div>
            </div>
          </div>
          <div v-show="waitData.couponData!==undefined&&waitData.couponData!==null&&waitData.couponData.length>0" class="txt1 clearfix_">
            <div class="fl txt1_name">优惠券：</div>
            <div class="fl txt1_goods">
              <div v-for="(item,index) in waitData.couponData" :key="index" class="txt1_goods_item clearfix_">
                <div class="txt1_goods_item_name fl">{{item.couponRuleName}}</div>
                <div class="txt1_goods_item_txt fl">¥{{item.money}} *{{item.couponNum}}</div>
              </div>
            </div>
          </div>
          <div v-show="parseInt(waitData.couponReturnMoney)" class="txt1 clearfix_">
            <div class="fl txt1_name">优惠券扣款：</div>
            <div class="fl txt1_txt">{{waitData.couponReturnMoney}}</div>
          </div>
          <div v-show="waitData.score" class="txt1 clearfix_">
            <div class="fl txt1_name">积分：</div>
            <div class="fl txt1_txt">{{waitData.score}}</div>
          </div>
          <div v-show="parseInt(waitData.postageMoney)" class="txt1 clearfix_">
            <div class="fl txt1_name">运费：</div>
            <div class="fl txt1_txt">{{waitData.postageMoney}}</div>
          </div>
          <div class="txt1 clearfix_">
            <div style="margin-top:2px;" class="fl txt1_name">退款金额：</div>
            <div class="fl txt1_txt"><span>¥{{waitData.totalAmount}}</span></div>
          </div>
        </div>
        <div class="return_goods_mode">
          <ul>
            <li v-show="waitData.returnType==2" class="clearfix_ return_goods_mode_item">
              <p class="fl return_goods_mode_txt1">物流公司：</p>
              <div class="fl">
                <el-select style="width:142px;margin-right:30px;" v-model="firmsListName" placeholder="请选择">
                  <el-option v-for="(item,index) in waitData.firmData" :key="index" :label="item.name" :value="item.id"> </el-option>
                </el-select>
              </div>
            </li>
            <li v-show="waitData.returnType==2" class="clearfix_ return_goods_mode_item">
              <p class="fl return_goods_mode_txt1">物流单号：</p>
              <div class="fl">
                <input class="return_goods_mode_input" v-model="logisticsNum">
              </div>
            </li>
            <li v-show="waitData.returnType==2" class="clearfix_ return_goods_mode_item">
              <p class="fl return_goods_mode_txt1">发货说明：</p>
              <div class="fl">
                <input class="return_goods_mode_input" v-model="firmMessage">
              </div>
            </li>
            <li v-show="waitData.returnType==2" class="clearfix_ return_goods_mode_item">
              <div class="clearfix_">
                <div style="margin-top:5px;" class="fl runter_title">上传图片：</div>
                <ul class="runter_upload fl clearfix_">
                  <li v-show="firmsImg" class="fl"><img :src="firmsImg" alt=""></li>
                  <li v-show="!firmsImg" class="add_box fl">
                    <p><img :src="addImg" alt=""></p>
                    <p>上传凭证</p>
                    <input class="file img_btn" type="file" accept="image/png,image/gif,image/jpeg" @change="firmsUploadImgFn($event)"/>
                  </li>
                </ul>
              </div>
            </li>
            <li v-show="waitData.returnType==1" class="clearfix_ return_goods_mode_item">
              <p class="fl return_goods_mode_txt1">取件地址：</p>
              <div class="fl return_goods_take_address">
                <div class="return_goods_take_address_list">
                  <div class="return_goods_take_address_item clearfix_" v-for="(item,index) in takeAddressList" :key="index">
                    <div :class="(takeAddressId==item.id?'return_goods_take_address_item_title_active':'')" @click="selectTakeAddress(item.id)" class="fl return_goods_take_address_item_title">{{item.consignee}}</div>
                    <div class="fl return_goods_take_address_item_txt">{{item.consignee}} {{item.mobilePhone}} {{item.areaText}} {{item.address}}</div>
                  </div>
                </div>
              </div>
            </li>
            <li v-show="waitData.returnType==1" class="clearfix_ return_goods_mode_item">
              <p class="fl return_goods_mode_txt1">取件时间：</p>
              <p @click="takeTimeShowFn" class="fl return_goods_take_time" style="line-height:40px;">
                <span v-show="timeTxt">{{dayTxt}} {{timeTxt}}</span>
                <span v-show="!timeTxt">请选择</span>  
              </p>
            </li>
            <li class="clearfix_ return_goods_mode_item clearfix_">
              <div @click="firmsSubmit" class="runter_goods_btn fl"><span style="margin-left:76px;">提交</span></div>
              <div class="runter_goods_btn fl"><span style="background:#ccc;margin-left:20px;" @click="cancelReturnForOrder">全部取消</span></div>
            </li>
          </ul>
        </div>
      </div>
      <div v-show="step==3&&waitData.status==12" class="fl runter_goods_box_runter">
        <div class="runter_step2_title">
          <div class="txt1">退货中</div>
        </div>
        <div class="runter_step2_txt">
          <div class="">
            <div style="margin-bottom:10px;">您已成功发起退款申请,请耐心等待商家处理</div>
            <div style="margin-bottom:10px;">· 商家同意或者超时未处理，系统将退款给您</div>
            <div style="margin-bottom:10px;">· 如果商家拒绝，您可以修改退款申请后再次发起，商家会重新处理</div>
          </div>
          <div class="txt1">退货清单</div>
          <div class="txt1 clearfix_">
            <div>
              <div class="order_goods_information">
                <p class="order_goods_title">商品信息</p>
                <div class="order_goods_explain clearfix_">
                  <div class="fl goodsName">商品名称</div>
                  <div class="fl price">单价</div>
                  <div class="fl num">数量</div>
                  <div class="fl operation">商品操作</div>
                </div>
              </div>
              <ul class="order_goods_information_ul">
                <li  v-for="(item,index) in waitData.goodsData" :key="index" class="clearfix_">
                  <img class="fl" :src="item.pic?item.pic:timg" alt="">
                  <div class="goodsName fl"><p>{{item.goodsName}}</p><p>{{item.goodsUnitName}} {{item.property1}}</p></div>
                  <div class="price fl">¥{{item.salesMoney}}</div>
                  <div class="num fl">{{item.num}}</div>
                </li>
              </ul>
            </div>
          </div>
          <div v-show="waitData.giftData!==undefined&&waitData.giftData!==null&&waitData.giftData.length>0" class="txt1 clearfix_">
            <div class="fl txt1_name">赠品：</div> 
            <div class="fl txt1_goods">
              <div v-for="(item,index) in waitData.giftData" :key="index" class="txt1_goods_item clearfix_">
                <div class="txt1_goods_item_name fl">{{item.goodsName}}</div>
                <div class="txt1_goods_item_txt fl">{{item.goodsUnitName}} {{item.property1}} *{{item.num}}</div>
              </div>
            </div>
          </div>
          <div v-show="waitData.couponData!==undefined&&waitData.couponData!==null&&waitData.couponData.length>0" class="txt1 clearfix_">
            <div class="fl txt1_name">优惠券：</div>
            <div class="fl txt1_goods">
              <div v-for="(item,index) in waitData.couponData" :key="index" class="txt1_goods_item clearfix_">
                <div class="txt1_goods_item_name fl">{{item.couponRuleName}}</div>
                <div class="txt1_goods_item_txt fl">¥{{item.money}} *{{item.couponNum}}</div>
              </div>
            </div>
          </div>
          <div v-show="parseInt(waitData.couponReturnMoney)" class="txt1 clearfix_">
            <div class="fl txt1_name">优惠券扣款：</div>
            <div class="fl txt1_txt">{{waitData.couponReturnMoney}}</div>
          </div>
          <div v-show="waitData.score" class="txt1 clearfix_">
            <div class="fl txt1_name">积分：</div>
            <div class="fl txt1_txt">{{waitData.score}}</div>
          </div>
          <div v-show="parseInt(waitData.postageMoney)" class="txt1 clearfix_">
            <div class="fl txt1_name">运费：</div>
            <div class="fl txt1_txt">{{waitData.postageMoney}}</div>
          </div>
          <div class="txt1 clearfix_">
            <div style="margin-top:2px;" class="fl txt1_name">退款金额：</div>
            <div class="fl txt1_txt"><span>¥{{waitData.totalAmount}}</span></div>
          </div>
        </div>
      </div>
      <div v-show="step==4" class="fl runter_goods_box_runter">
        <div class="runter_step2_title">
          <div class="txt1">退款成功</div>
        </div>
        <div class="runter_step2_txt">
          <div class="runter_goods_allprice">
            <div class="txt1">退款总金额：<span style="color:#f12002;">¥{{waitData.totalAmount}}</span></div>
            <div class="txt_box">
              <div v-show="parseInt(waitData.cardMoney)" class="txt_item clearfix_"><span class="fl">储值退款：</span><span class="fl">¥{{waitData.cardMoney}}</span></div>
              <div v-show="parseInt(waitData.memberMoney)"  class="txt_item clearfix_"><span class="fl">余额退款：</span><span class="fl">¥{{waitData.memberMoney}}</span></div>
              <div v-show="waitData.payType" class="txt_item clearfix_"><span class="fl">{{waitData.payType}}退款：</span><span class="fl">¥{{waitData.payTypeMoney}}</span></div>
            </div>
          </div>
          <div class="txt1">退货清单</div>
          <div class="txt1 clearfix_">
            <div>
              <div class="order_goods_information">
                <p class="order_goods_title">商品信息</p>
                <div class="order_goods_explain clearfix_">
                  <div class="fl goodsName">商品名称</div>
                  <div class="fl price">单价</div>
                  <div class="fl num">数量</div>
                  <div class="fl operation">商品操作</div>
                </div>
              </div>
              <ul class="order_goods_information_ul">
                <li  v-for="(item,index) in waitData.goodsData" :key="index" class="clearfix_">
                  <img class="fl" :src="item.pic?item.pic:timg" alt="">
                  <div class="goodsName fl"><p>{{item.goodsName}}</p><p>{{item.goodsUnitName}} {{item.property1}}</p></div>
                  <div class="price fl">¥{{item.salesMoney}}</div>
                  <div class="num fl">{{item.num}}</div>
                </li>
              </ul>
            </div>
          </div>
          <div v-show="waitData.giftData!==undefined&&waitData.giftData!==null&&waitData.giftData.length>0" class="txt1 clearfix_">
            <div class="fl txt1_name">赠品：</div> 
            <div class="fl txt1_goods">
              <div v-for="(item,index) in waitData.giftData" :key="index" class="txt1_goods_item clearfix_">
                <div class="txt1_goods_item_name fl">{{item.goodsName}}</div>
                <div class="txt1_goods_item_txt fl">{{item.goodsUnitName}} {{item.property1}} *{{item.num}}</div>
              </div>
            </div>
          </div>
          <div v-show="waitData.couponData!==undefined&&waitData.couponData!==null&&waitData.couponData.length>0" class="txt1 clearfix_">
            <div class="fl txt1_name">优惠券：</div>
            <div class="fl txt1_goods">
              <div v-for="(item,index) in waitData.couponData" :key="index" class="txt1_goods_item clearfix_">
                <div class="txt1_goods_item_name fl">{{item.couponRuleName}}</div>
                <div class="txt1_goods_item_txt fl">¥{{item.money}} *{{item.couponNum}}</div>
              </div>
            </div>
          </div>
          <div v-show="parseInt(waitData.couponReturnMoney)" class="txt1 clearfix_">
            <div class="fl txt1_name">优惠券扣款：</div>
            <div class="fl txt1_txt">{{waitData.couponReturnMoney}}</div>
          </div>
          <div v-show="waitData.score" class="txt1 clearfix_">
            <div class="fl txt1_name">积分：</div>
            <div class="fl txt1_txt">{{waitData.score}}</div>
          </div>
          <div v-show="parseInt(waitData.postageMoney)" class="txt1 clearfix_">
            <div class="fl txt1_name">运费：</div>
            <div class="fl txt1_txt">{{waitData.postageMoney}}</div>
          </div>
          <!-- <div class="txt1 clearfix_">
            <div style="margin-top:2px;" class="fl txt1_name">退款金额：</div>
            <div class="fl txt1_txt"><span>¥{{waitData.totalAmount}}</span></div>
          </div> -->
        </div>
      </div>
      <div v-show="returningGoodsList.length" class="fl runter_goods_box_goods">
        <div class="runter_goods_box_goods_title">{{returningGoodsListTitle}}</div>
        <div style="border-bottom:1px solid #e8e8e8;">
          <div v-for="(item,index) in returningGoodsList" :key="index" class="runter_goods_details clearfix_">
            <div class="fl runter_goods_details_img"><img :src="item.pic" alt=""></div>
            <div class="fl runter_goods_details_txt">
              <p style="color:#333;">{{item.goodsName}}</p>
              <p style="color:#999;">{{item.goodsUnitName}} {{item.property1}}</p>
              <p style="color:#999;">{{item.salesMoney}}*{{item.num}}</p>
            </div>
          </div>
        </div>
        <div class="order_txt_tenant">
          <div class="txt1 clearfix_">
            <div class="fl txt1_name">商户：</div>
            <div class="fl txt1_txt">{{waitTenantData.tenant}}</div>
          </div>
          <div v-show="waitTenantData.tenantPhone" class="txt1 clearfix_">
            <div class="fl txt1_name">联系电话：</div>
            <div class="fl txt1_txt">{{waitTenantData.tenantPhone}}</div>
          </div>
          <div class="txt1 clearfix_">
            <div class="fl txt1_name">订单编号：</div>
            <div class="fl txt1_txt">{{waitTenantData.orderScode}}</div>
          </div>
        </div>
      </div>
    </div>
    <div v-show="teakTimeShow" class="return_goods_take_time_mask">
      <div class="return_goods_take_time_box">
        <div class="return_goods_take_time_box1">
          <div class="return_goods_take_time_title clearfix_">
            <div class="fl return_goods_take_time_title_txt">取件时间</div>
            <div @click="teakTimeHideFn" class="fr return_goods_take_time_title_hide">×</div>
          </div>
          <div class="return_goods_take_time_list">
            <div v-for="(item,index) in waitData.takeDeliveryDate" :key="index" class="return_goods_take_time_item">
              <div class="return_goods_take_time_item_txt">{{item.date}} {{item.week}}</div>
              <div class="return_goods_take_time_val clearfix_">
                <div @click="selectTakeTime(index,idx)" v-for="(val,idx) in item.items" :key="idx" :class="(val.isSelect?'return_goods_take_time_val_txt_active':'')" class="fl return_goods_take_time_val_txt">{{val.time}}</div>
              </div>
            </div>
          </div>
          <div class="return_goods_take_time_tips">温馨提示：我们会努力按照您指定的时间取件，但因为天气、交通等各类因素影响，可能偶尔出现延误，请谅解！</div>
          <div class="return_goods_take_time_btn">
            <div @click="teakTimeHideFn" class="return_goods_take_time_btn_txt">确定</div>
            <div @click="teakTimeHideFn" class="return_goods_take_time_btn_txt return_goods_take_time_btn_txt1">取消</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import Qs from 'qs'
import { ip,overtime } from '../../assets/js/public.js'
export default {
  data(){
    return{
      logisticsNum:'',
      cause:null,
      firmsListName:'',
      returnGoodsMode:null,
      returnGoodsModeStep3:'1',
      num:0,
      addImg:require('../../assets/img/add_address_1.png'),
      runter_bg1:require('../../assets/img/runter_bg1.png'),
      runter_bg2:require('../../assets/img/runter_bg2.png'),
      runter_bg3:require('../../assets/img/runter_bg3.png'),
      goodsData:{},
      returningGoodsList:[],
      getReturnData:{},
      upLoadList:[],
      upLoadList_:[],
      msg:'',
      step:1,
      returnMessageData:{},
      refuseReason:'',
      isAllow:0,
      firmsList:[],
      mfirmId:'',
      pickUpPartsTime:'',
      returnSeveralTimes:false,
      waitData:{},
      waitTenantData:{},
      returningGoodsListTitle:'',
      timg:require('../../assets/img/timg.gif'),
      totalReturn:0,
      returnType:-1,
      canceTxt:'',
      firmMessage:'',
      firmsImg:'',
      firmsImg_:'',
      addressInfo:[],
      teakTimeShow:false,
      dayTxt:'',
      timeTxt:'',
      takeAddressList:[],
      takeAddressId:''
    }
  },
  mounted:function(){
    var t_=this
    t_.step=t_.$route.query.step
    t_.isAllow=t_.$route.query.isAllow
    t_.num=t_.$route.query.num
    t_.totalReturn=t_.$route.query.totalReturn
    if(t_.step==1){
      if(t_.totalReturn){
        t_.getApplyReturnInfoForOrder()
      }else{
        t_.getApplyReturnInfo()
      }
    }else{
      t_.mallReturnInfo()
    }
  },
  methods:{
    selectTakeAddress:function(id){
      var t_=this
      t_.takeAddressId=id
    },
    getAddressByMemberId:function(){
      var t_=this
      var data0bj=Qs.stringify({
        tamp:localStorage.tamp?localStorage.tamp:'',
        channel:2,
        page:1,
        pagesize:20
      })
      axios.post(`${ip}formWorkInterface/getAddressByMemberId`,data0bj).then(res=>{
        if(res.data.code==0){
          t_.takeAddressList=res.data.results.rows
        }
      })
    },
    selectTakeTime:function(index,idx){
      var t_=this
      if(t_.waitData.takeDeliveryDate[index].items[idx].isSelect){
        t_.waitData.takeDeliveryDate[index].items[idx].isSelect=false
        t_.dayTxt=''
        t_.timeTxt=''
      }else{
        t_.waitData.takeDeliveryDate.forEach(function(item,i){
          item.items.forEach(function(val,j){
            val.isSelect=false
          })
        })
        t_.waitData.takeDeliveryDate[index].items[idx].isSelect=true
        t_.dayTxt=t_.waitData.takeDeliveryDate[index].date
        t_.timeTxt=t_.waitData.takeDeliveryDate[index].items[idx].time
      }
    },
    takeTimeShowFn:function(){
      var t_=this
      t_.teakTimeShow=true
    },
    teakTimeHideFn:function(){
      var t_=this
      t_.teakTimeShow=false
    },
    firmsSubmit:function(){
      var t_=this
      var data0bj={
        tamp:localStorage.tamp?localStorage.tamp:'',
        channel:2,
        id:t_.waitData.id
      }
      if(t_.waitData.returnType==2){
        if(!t_.firmsListName)return t_.$message({
          message:'请选择物流公司',
          center:true,
          type:'warning'
        })
        if(!t_.logisticsNum)return t_.$message({
          message:'请填写物流单号',
          center:true,
          type:'warning'
        })
        data0bj.firmId=t_.firmsListName
        data0bj.logisticsScode=t_.logisticsNum
        data0bj.logisticsRemart=t_.firmMessage
        data0bj.logisticsPic=t_.firmsImg_
      }else if(t_.waitData.returnType==1){
        if(!t_.takeAddressId)return t_.$message({
          message:'请选择取件地址',
          center:true,
          type:'warning'
        })
        if(!t_.timeTxt)return t_.$message({
          message:'请选择取件时间',
          center:true,
          type:'warning'
        })
        data0bj.addressId=t_.takeAddressId
        data0bj.date=t_.dayTxt
        data0bj.time=t_.timeTtxt
      }
      data0bj=Qs.stringify(data0bj)
      axios.post(`${ip}formWorkInterface/saveReturnType`,data0bj).then(res=>{
        if(overtime(res.data.code)){
          localStorage.removeItem('tamp')
          localStorage.removeItem('name')
          return this.$router.push({
            path: '/LoginHome?state=1',
            query: {redirect: this.$route.fullPath,oldRoter:this.$route.path,oldData:this.$route.query}
          });
          return
          this.$router.go(0);
        }
        if(res.data.code==300){
          var href=this.$router.resolve({name:'err404',query:{txt:res.data.message}})
          return window.open(href.href,'_blank')
        }
        if(res.data.code==0){
          t_.$message({
            message:res.data.message,
            center:true,
            type:'success'
          })
          t_.$router.push({name:'returnGoodsList',query:{orderId:t_.$route.query.orderId}})
          // t_.$router.go(-1)
        }else{
          t_.$message({
            message:res.data.message,
            center:true,
            type:'warning'
          })
        }
      })
    },
    getPickUpPartsTime:function(val){
      this.pickUpPartsTime=val
    },
    againApply:function(){
      var t_=this
      let query = this.$router.history.current.query
      let path = this.$router.history.current.path
      //对象的拷贝
      let newQuery = JSON.parse(JSON.stringify(query))
      newQuery.step = 1
      t_.$router.push({ path, query: newQuery })
      t_.step=1
    },
    cancelRunter:function(){
      var t_=this
      this.$confirm('确定要取消申请退货吗？','提示',{
        confirmButtonText:'确定',
        cancelButtonText:'取消',
        distinguishCancelAndClose:true,
        type:'warning'
      }).then(()=>{
        var data0bj={
          tamp:localStorage.tamp?localStorage.tamp:'',
          channel:2,
          id:t_.returnMessageData.id
        }
        data0bj=Qs.stringify(data0bj)
        axios.post(`${ip}formWorkInterface/cancelReturnGoods`,data0bj).then(res=>{
          if(overtime(res.data.code)){
            localStorage.removeItem('tamp')
            localStorage.removeItem('name')
            return this.$router.push({
              path: '/LoginHome?state=1',
              query: {redirect: this.$route.fullPath,oldRoter:this.$route.path,oldData:this.$route.query}
            });
            return
            this.$router.go(0);
          }
          if(res.data.code==300){
            var href=this.$router.resolve({name:'err404',query:{txt:res.data.message}})
            return window.open(href.href,'_blank')
          }
          if(res.data.code==0){
            t_.$message({
              message:res.data.message,
              center:true,
              type:'success'
            })
            if(t_.returnSeveralTimes){
              t_.$router.go(-2)
            }else{
              t_.$router.go(-1)
            }
          }else{
            t_.$message({
              message:res.data.message,
              center:true,
              type:'warning'
            })
          }
        })
      }).catch(action=>{})
    },
    firmsUploadImgFn:function(ev){
      var t_=this
      let file = ev.target.files
      let param = new FormData()
      param.append('file',file[0],file[0].name)
      param.append('channel',2)
      param.append('tamp',localStorage.tamp?localStorage.tamp:'')
      let config = {
        headers:{'Content-Type':'multipart/form-data'}
      }
      axios.post(`${ip}formWorkInterface/uploadImg`,param,config).then(res=>{
        if(overtime(res.data.code)){
          localStorage.removeItem('tamp')
          localStorage.removeItem('name')
          return this.$router.push({
            path: '/LoginHome?state=1',
            query: {redirect: this.$route.fullPath,oldRoter:this.$route.path,oldData:this.$route.query}
          });
          this.$router.go(0);
        }
        if(res.data.code==300){
          var href=this.$router.resolve({name:'err404',query:{txt:res.data.message}})
          return window.open(href.href,'_blank')
        }
        if(res.data.code==0){
          res.data.url='data:image/png;base64,'+res.data.url
          t_.firmsImg=res.data.url
          t_.firmsImg_=res.data.url1
          console.log(  )
          $('input[type="file"]').val("")
        }else{
          t_.$message({
            message:'上传图片失败，请重新上传',
            center:true,
            type:'warning'
          })
        }
      })
    },
    uploadImgFn:function(e){
      var t_=this
      let file = e.target.files
      if(t_.upLoadList.length+file.length>5)return t_.$message({
        message:'最多选择5张图片',
        center:true,
        type:'warning'
      })
      for(var i=0;i<file.length;i++){
        let param = new FormData()
        param.append('file',file[i],file[i].name)
        param.append('channel',2)
        param.append('tamp',localStorage.tamp?localStorage.tamp:'')
        let config = {
          headers:{'Content-Type':'multipart/form-data'}
        }
        axios.post(`${ip}formWorkInterface/uploadImg`,param,config).then(res=>{
          if(overtime(res.data.code)){
            localStorage.removeItem('tamp')
            localStorage.removeItem('name')
            return this.$router.push({
              path: '/LoginHome?state=1',
              query: {redirect: this.$route.fullPath,oldRoter:this.$route.path,oldData:this.$route.query}
            });
            this.$router.go(0);
          }
          if(res.data.code==300){
            var href=this.$router.resolve({name:'err404',query:{txt:res.data.message}})
            return window.open(href.href,'_blank')
          }
          if(res.data.code==0){
            res.data.url='data:image/png;base64,'+res.data.url
            t_.upLoadList.push(res.data.url)
            t_.upLoadList_.push(res.data.url1)
            $('input[type="file"]').val("")
          }else{
            t_.$message({
              message:'上传图片失败，请重新上传',
              center:true,
              type:'warning'
            })
          }
        })
      }
    },
    submitForOrder:function(){
      var t_=this
      if(!t_.cause)return t_.$message({
        message:'请选择退款原因！',
        center:true,
        type:'warning'
      })
      if(t_.returnType!=-1){
        if(!t_.returnGoodsMode)return t_.$message({
          message:'请选择退货方式！',
          center:true,
          type:'warning'
        })
      }
      var data0bj={
        tamp:localStorage.tamp?localStorage.tamp:'',
        channel:2,
        id:t_.$route.query.orderId,
        reason:t_.cause,
        returnType:t_.returnGoodsMode,
        remark:t_.msg,
        picUrl:JSON.stringify(t_.upLoadList_)
      }
      data0bj=Qs.stringify(data0bj)
      axios.post(`${ip}formWorkInterface/saveMallReturnApplyForOrder`,data0bj).then(res=>{
        if(overtime(res.data.code)){
          localStorage.removeItem('tamp')
          localStorage.removeItem('name')
          return this.$router.push({
            path: '/LoginHome?state=1',
            query: {redirect: this.$route.fullPath,oldRoter:this.$route.path,oldData:this.$route.query}
          });
          this.$router.go(0);
        }
        if(res.data.code==300){
          var href=this.$router.resolve({name:'err404',query:{txt:res.data.message}})
          return window.open(href.href,'_blank')
        }
        if(res.data.code==0){
          t_.$message({
            message:res.data.message,
            center:true,
            type:'success'
          })
          let query = this.$router.history.current.query
          let path = this.$router.history.current.path
          //对象的拷贝
          let newQuery = JSON.parse(JSON.stringify(query))
          newQuery.step = 2
          newQuery.runterId = res.data.id
          newQuery.orderId = res.data.orderId
          newQuery.type=1
          t_.$router.push({ path, query: newQuery })
          t_.returnSeveralTimes=true
          t_.step=2
          t_.mallReturnInfo()
        }else{
          t_.$message({
            message:res.data.message,
            center:true,
            type:'warning'
          })
        }
      })
    },
    submit:function(){
      var t_=this
      if(!t_.cause)return t_.$message({
        message:'请选择退款原因！',
        center:true,
        type:'warning'
      })
      if(t_.returnType!=-1){
        if(!t_.returnGoodsMode)return t_.$message({
          message:'请选择退货方式！',
          center:true,
          type:'warning'
        })
      }
      var data0bj={
        tamp:localStorage.tamp?localStorage.tamp:'',
        channel:2,
        id:t_.$route.query.id,
        returnNum:t_.num,
        reason:t_.cause,
        returnType:t_.returnGoodsMode,
        remark:t_.msg,
        picUrl:JSON.stringify(t_.upLoadList_)
      }
      data0bj=Qs.stringify(data0bj)
      axios.post(`${ip}formWorkInterface/saveMallReturnApply`,data0bj).then(res=>{
        if(overtime(res.data.code)){
          localStorage.removeItem('tamp')
          localStorage.removeItem('name')
          return this.$router.push({
            path: '/LoginHome?state=1',
            query: {redirect: this.$route.fullPath,oldRoter:this.$route.path,oldData:this.$route.query}
          });
          this.$router.go(0);
        }
        if(res.data.code==300){
          var href=this.$router.resolve({name:'err404',query:{txt:res.data.message}})
          return window.open(href.href,'_blank')
        }
        if(res.data.code==0){
          t_.$message({
            message:res.data.message,
            center:true,
            type:'success'
          })
          let query = this.$router.history.current.query
          let path = this.$router.history.current.path
          //对象的拷贝
          let newQuery = JSON.parse(JSON.stringify(query))
          newQuery.step = 2
          newQuery.runterId = res.data.id
          newQuery.orderId = res.data.orderId
          newQuery.type=1
          t_.$router.push({ path, query: newQuery })
          t_.returnSeveralTimes=true
          t_.step=2
          t_.mallReturnInfo()
        }else{
          t_.$message({
            message:res.data.message,
            center:true,
            type:'warning'
          })
        }
      })
    },
    mallReturnInfo:function(){
      var t_=this
      var data0bj=Qs.stringify({
        tamp:localStorage.tamp?localStorage.tamp:'',
        channel:2,
        id:t_.$route.query.orderId,
        type:t_.$route.query.type
      })
      axios.post(`${ip}formWorkInterface/mallReturnInfo`,data0bj).then(res=>{
        if(overtime(res.data.code)){
          localStorage.removeItem('tamp')
          localStorage.removeItem('name')
          return this.$router.push({
            path: '/LoginHome?state=1',
            query: {redirect: this.$route.fullPath,oldRoter:this.$route.path,oldData:this.$route.query}
          });
          this.$router.go(0);
        }
        if(res.data.code==300){
          var href=this.$router.resolve({name:'err404',query:{txt:res.data.message}})
          return window.open(href.href,'_blank')
        }
        if(res.data.code==0){
          if(res.data.data.status==1){
            t_.returningGoodsList=res.data.data.orderData.orderGoodsData
            t_.waitTenantData=res.data.data.orderData
            t_.returningGoodsListTitle=res.data.data.orderData.title
          }else{

          }
          t_.waitData=res.data.data
          
          if(t_.waitData.status==1)t_.step=2
          if(t_.waitData.status==2){
            t_.step=3
            t_.addressInfo=t_.waitData.addressInfo
            if(t_.waitData.returnType==1)t_.getAddressByMemberId()
            if(t_.waitData.takeDeliveryDate.length){
              t_.waitData.takeDeliveryDate.forEach(function(item,index) {
                item.items.forEach(function(val,idx){
                  t_.$set(val,'isSelect',false)
                })
              })
            }
          }
          if(t_.waitData.status==3)t_.step=3
          if(t_.waitData.status==4){
            t_.step=2
            t_.canceTxt='买家已取消'
          }
          if(t_.waitData.status==12)t_.step=3
          if(t_.waitData.status==13)t_.step=4
        }
      })
    },
    cancelReturnForOrder:function(){
      var t_=this
      this.$confirm('是否全部取消申请退货','提示',{
        confirmButtonText:'确定',
        cancelButtonText:'取消',
        distinguishCancelAndClose:true,
        type:'warning'
      }).then(()=>{
        var data0bj=Qs.stringify({
          tamp:localStorage.tamp?localStorage.tamp:'',
          channel:2,
          id:t_.$route.query.orderId
        })
        axios.post(`${ip}formWorkInterface/cancelReturnForOrder`,data0bj).then(res=>{
          if(overtime(res.data.code)){
            localStorage.removeItem('tamp')
            localStorage.removeItem('name')
            return this.$router.push({
              path: '/LoginHome?state=1',
              query: {redirect: this.$route.fullPath,oldRoter:this.$route.path,oldData:this.$route.query}
            });
            this.$router.go(0);
          }
          if(res.data.code==300){
            var href=this.$router.resolve({name:'err404',query:{txt:res.data.message}})
            return window.open(href.href,'_blank')
          }
          if(res.data.code==0){
            t_.$message({
              message:'全部取消退货成功',
              center:true,
              type:'success'
            })
            setTimeout(function(){
              if(t_.returnSeveralTimes){
                t_.$router.go(-2)
              }else{
                t_.$router.go(-1)
              }
            },3000,t_)
          }else{
            t_.$message({
              message:res.data.code,
              center:true,
              type:'warning'
            })
          }
        })
      }).catch(action=>{})
    },
    cancelReturnForGoods:function(id){
      var t_=this
      this.$confirm('是否取消申请退货','提示',{
        confirmButtonText:'确定',
        cancelButtonText:'取消',
        distinguishCancelAndClose:true,
        type:'warning'
      }).then(()=>{
        var data0bj=Qs.stringify({
          tamp:localStorage.tamp?localStorage.tamp:'',
          channel:2,
          id:id
        })
        axios.post(`${ip}formWorkInterface/cancelReturnForGoods`,data0bj).then(res=>{
          if(overtime(res.data.code)){
            localStorage.removeItem('tamp')
            localStorage.removeItem('name')
            return this.$router.push({
              path: '/LoginHome?state=1',
              query: {redirect: this.$route.fullPath,oldRoter:this.$route.path,oldData:this.$route.query}
            });
            this.$router.go(0);
          }
          if(res.data.code==300){
            var href=this.$router.resolve({name:'err404',query:{txt:res.data.message}})
            return window.open(href.href,'_blank')
          }
          if(res.data.code==0){
            if(res.data.status){
            t_.$message({
              message:res.data.message,
              center:true,
              type:'success'
            })
            setTimeout(function(){
              if(t_.returnSeveralTimes){
                t_.$router.go(-2)
              }else{
                t_.$router.go(-1)
              }
            },3000,t_)
            }else{
              t_.$message({
                message:res.data.message,
                center:true,
                type:'success'
              })
              t_.mallReturnInfo()
            }
          }else{
            t_.$message({
              message:res.data.code,
              center:true,
              type:'warning'
            })
          }
        })
      }).catch(action=>{})
    },
    ChangeNum:function(n){
      var t_=this
      if(n==-1){
        t_.num=--t_.num
      }else if(n==0){
        var reg = new RegExp(/^\d+$/);
        if(!reg.test(t_.num)){
          t_.num=t_.goodsData.returnNum
          return t_.$message({
            message:'只能输入数字',
            center:true,
            type:'warning'
          })
        }
      }else if(n==1){
        t_.num=++t_.num
      }
      if(t_.num>t_.goodsData.returnNum||t_.num<1){
          t_.num=t_.goodsData.returnNum
          return t_.$message({
            message:'请核对要退货退款数量',
            center:true,
            type:'warning'
          })
        }
      t_.getReturn(t_.num)
    },
    getApplyReturnInfoForOrder:function(){
      var t_=this
      var data0bj=Qs.stringify({
        tamp:localStorage.tamp?localStorage.tamp:'',
        channel:2,
        id:t_.$route.query.orderId
      })
      axios.post(`${ip}formWorkInterface/getApplyReturnInfoForOrder`,data0bj).then(res=>{
        if(overtime(res.data.code)){
          localStorage.removeItem('tamp')
          localStorage.removeItem('name')
          return this.$router.push({
            path: '/LoginHome?state=1',
            query: {redirect: this.$route.fullPath,oldRoter:this.$route.path,oldData:this.$route.query}
          });
          this.$router.go(0);
        }
        if(res.data.code==300){
          var href=this.$router.resolve({name:'err404',query:{txt:res.data.message}})
          return window.open(href.href,'_blank')
        }
        if(res.data.code==0){
          if(res.data.data.returnType>0)t_.returnGoodsMode=res.data.data.returnType+''
          t_.returnType=res.data.data.returnType
        }
      })
    },
    getApplyReturnInfo:function(){
      var t_=this
      var data0bj=Qs.stringify({
        tamp:localStorage.tamp?localStorage.tamp:'',
        channel:2,
        id:t_.$route.query.id,
        num:t_.num
      })
      axios.post(`${ip}formWorkInterface/getApplyReturnInfo`,data0bj).then(res=>{
        if(overtime(res.data.code)){
          localStorage.removeItem('tamp')
          localStorage.removeItem('name')
          return this.$router.push({
            path: '/LoginHome?state=1',
            query: {redirect: this.$route.fullPath,oldRoter:this.$route.path,oldData:this.$route.query}
          });
          this.$router.go(0);
        }
        if(res.data.code==300){
          var href=this.$router.resolve({name:'err404',query:{txt:res.data.message}})
          return window.open(href.href,'_blank')
        }
        if(res.data.code==0){
          if(res.data.data.returningGoodsInfo.returnType>0)t_.returnGoodsMode=res.data.data.returningGoodsInfo.returnType+''
          t_.goodsData=res.data.data.returningGoodsInfo
          t_.returnType=res.data.data.returningGoodsInfo.returnType
          t_.num=t_.goodsData.enableReturnNum
          if(res.data.data.returningGoodsList.length)t_.returningGoodsList=res.data.data.returningGoodsList,t_.returningGoodsListTitle=res.data.data.title
        }
      })
    },
  }
}
</script>
<style scoped>
  .runter_goods_box{
    width: 1025px;
    border: 1px solid #ddd;
    background: #fff;
    height: 800px;
  }
  .runter_goods_box_runter{
    width: 657px;
    border-right: 1px solid #ddd;
    height: 780px;
    padding: 20px 64px 0 64px;
  }
  .runter_goods_box_runter>div{
    margin-bottom: 25px;
  }
  .runter_goods_box_goods{
    width: 239px;
    height: 685px;
    padding: 20px 0;
  }
  .runter_goods_box_runter .runter_title{
    width: 70px;
    color:#000;
  }
  .runter_shopp_pic{
    width: 76px;
    height: 76px;
    margin-right: 20px;
  }
  .runter_shopp_pic img{
    width: 76px;
    height: 76px;
  }
  .runter_shopp_name p:first-child{
    margin-top: 7px;
    margin-bottom: 12px;
  }
  .runter_goods_box_runter .addanredueBox{
    height: 25px;
  }
  .runter_goods_box_runter .addanredueBox button{
    float: left;
    background: 0;
    border: 1px solid #ccc;
    height: 25px;
    line-height: 22px;
    width: 25px;
  }
  .runter_goods_box_runter .addanredueBox input{
    width: 50px;
    /* margin: 0 10px; */
    text-align: center;
    background: 0;
    border: 1px solid #ccc;
    height: 23px;
    line-height: 23px;
    border-left: 0;
    float: left;
    border-right: 0;
  }
  .runter_goods_box_runter .el-input__suffix{
    /* top:41px; */
  }
  .runter_text textarea{
    width: 478px;
    height: 131px;
    border: 1px solid #ddd;
    line-height: 20px;
  }
  .runter_upload li{
    width: 88px;
    height: 88px;
    border: 1px solid #ddd;
    margin-right: 10px;
  }
  .runter_upload li img{
    width: 88px;
    height: 88px;
  }
  .runter_upload .add_box{
    width: 88px;
    height: 88px;
    border: 1px dashed #ddd;
    cursor: pointer;
    position: relative;
  }
  .runter_upload .add_box .img_btn{
    width: 88px;
    height: 88px;
    position: absolute;
    top:0;
    left:0;
    opacity: 0;
  }
  .runter_upload .add_box img{
    width: 22px;
    height: 22px;
  }
  .runter_upload .add_box p{
    text-align: center;
    color:#999;
  }
  .runter_upload .add_box p:first-child{
    margin-top: 18px;
    margin-bottom: 10px;
  }
  .runter_upload .add_box p:last-child{
    margin-top:8px;
  }
  .runter_goods_box_goods_title{
    width: 100%;
    font-size: 16px;
    color: #3c3c3c;
    height: 36px;
    border-bottom:1px solid #e8e8e8;
    text-indent: 20px;
  }
  .runter_goods_details{
    width: 199px;
    padding: 0 20px;
    margin-bottom:15px;
  }
  /* .runter_goods_details:last-child{
    border-bottom:1px solid #e8e8e8;
  } */
  .runter_goods_details_img{
    width: 54px;
    height: 54px;
    margin-right:10px;
    margin-top: 16px;
  }
  .runter_goods_details_img img{
    width: 54px;
    height: 54px;
  }
  .runter_goods_details p{
    line-height: 18px;
  }
  .runter_goods_details p:first-child{
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    line-height: 18px;
  }
  .runter_goods_details_txt{
    width: 135px;
    margin-top:7px;
  }
  .runter_goods_info li{
    margin-bottom:20px;
  }
  .runter_goods_info span{
    width: 60px;
    color:#9c9c9c;
    display: inline-block;
    text-align: right;
  }
  .runter_goods_info em{
    color:#3c3c3c;
    display: inline-block;
  }
  .runter_goods_btn span{
    width: 77px;
    height: 30px;
    background: #dd2727;
    border-radius: 5px;
    border: 0;
    color: #fff;
    margin-left: 70px;
    display: inline-block;
    text-align: center;
    line-height: 30px;
    cursor: pointer;
  }
  .runter_bg_box{
    width: 100%;
    height: 38px;
    margin-bottom: 10px;
  }
  .runter_bg_box .runter_bg1{
    width: 241px;
    height: 38px;
    background: #ccc;
    text-align: center;
    line-height: 38px;
    color:#fff;
  }
  .runter_bg_box .runter_bg_active{
    background: #dd2727;
  }
  .runter_bg_box .runter_bg1 span{
    width: 20px;
    height: 20px;
    display: inline-block;
    text-align: center;
    line-height: 20px;
    background: #fff;
    border-radius: 50%;
    margin-right: 5px;
    color:#ccc;
  }
  .runter_bg_box .runter_bg1 .span_active{
    color:#dd2727;
  }
  .runter_step2_title{
    border-bottom: 1px solid #e8e8e8;
    margin-bottom: 20px;
  }
  .runter_step2_title .txt1{
    font-size: 18px;
    color:#4c4c4c;
    font-weight: 900;
    margin-bottom: 20px;
  }
  .runter_step2_title .txt2{
    color:#999;
    margin-bottom: 20px;
  }
  .runter_step2_txt .txt1{
    color:#999;
    margin-bottom: 15px;
  }
  .runter_goods_allprice{
    border-bottom: 1px solid #ccc;
    margin-bottom: 25px;
    padding-bottom: 10px;
  }
  .runter_goods_allprice .txt1{
    font-size: 18px;
    margin-bottom: 25px;
  }
  /* .runter_goods_allprice .txt_box{
    margin-left: 25px;
  } */
  .runter_goods_allprice .txt_box .txt_item{
    margin-bottom: 12px;
  }
  .runter_goods_allprice .txt_box .txt_item:last-child{
    margin-bottom: 0;
  }
  .runter_goods_allprice .txt_box .txt_item span:first-child{
    width: 90px;
    text-align: right;
    margin-right: 10px;
  }
  .return_goods_order{
    border-bottom: 1px solid #ccc;
  }
  .return_goods_order ul li p:first-child{
    width: 69px;
    text-align: right;
  }
  .return_goods_order ul li{
    margin-bottom:12px;
  }
  .return_goods_order_title{
    font-size: 14px;
    margin-bottom:16px;
  }
  .return_goods_mode .return_goods_mode_txt1{
    line-height: 40px;
    margin-right: 15px;
  }
  .return_goods_mode .return_goods_mode_item{
    margin-bottom: 20px;
  }
  .return_goods_mode .return_goods_mode_input{
    width: 135px;
    height: 40px;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    padding-left: 5px;
  }
  .return_goods_mode_textarea{
    width: 500px;
    height: 80px;
    border:1px solid #dcdfe6;
    border-radius: 4px;
  }
  .txt1_name{
    width:80px;
  }
  .txt1_goods{
    width: 450px;
  }
  .txt1_goods_item_name{
    width: 300px;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    margin-right: 15px;
  }
  .txt1_txt span{
    color:#dd2727;
    font-size:16px;
  }
  .order_txt_tenant .txt1{
    color:#999;
    margin-bottom: 15px;
  }
  .order_txt_tenant{
    padding: 20px;
  }
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
      -webkit-appearance: none;
  }
  
  input[type="number"] {
      -moz-appearance: textfield;
  }




  .order_goods_information{
    margin-bottom: 20px;
  }
  .order_goods_title{
    color:#333;
    margin-bottom: 10px;
  }
  .order_goods_explain{
    width: 657px;
    height: 30px;
    background: #f5f5f5;
    color:#333;
  }
  .order_goods_explain div{
    line-height: 30px;
  }
  .order_goods_explain .goodsName{
    width: 267px;
    text-align: center;
    cursor: pointer;
    /* margin: 0 106px 0 82px; */
  }
  .order_goods_explain .price,.order_goods_explain .num{
    width: 130px;
    text-align: center;
  }
  .order_goods_explain .operation{
    width: 130px;
    text-align: center;
  }
  .order_goods_explain .subtotal{
    width: 130px;
    text-align: center;
  }
  .order_goods_information_ul{
    width: 657px;
    border-bottom: 1px solid #eee;
    margin-bottom: 25px;
  }
  .order_goods_information_ul li{
    margin-bottom: 20px;
  }
  .order_goods_information_ul img{
    width: 62px;
    height: 62px;
    margin-right: 20px;
  }
  .order_goods_information_ul .goodsName {
    width: 185px;
    line-height: 20px;
    cursor: pointer;
  }
  .order_goods_information_ul .goodsName p:first-child{
    width: 185px;
    line-height: 20px;
    cursor: pointer;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
  }
  .order_goods_information_ul .price,.order_goods_information_ul .num,.order_goods_information_ul .subtotal{
    width: 130px;
    height: 62px;
    text-align: center;
  }
  .order_goods_information_ul .operation{
    width: 130px;
    height: 62px;
    text-align: center;
  }
  .order_goods_information_ul .operation span{
    line-height: 18px;
    cursor: pointer;
    width: 100%;
  }
  .order_goods_information_ul .operation span:hover{
    color:#f12002;
  }
  .return_goods_take_time{
    line-height: 40px;
    cursor: pointer;
  }
  .return_goods_take_time_mask{
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background: rgba(0,0,0,.1);
  }
  .return_goods_take_time_box{
    width: 528px;
    height: 360px;
    background: rgba(0,0,0,.2);
    border-radius: 5px;
    position: absolute;
    left: 50%;
    top: 50%;
    -webkit-transform:translate(-50%,-50%);
    -moz-transform:translate(-50%,-50%);
    -o-transform:translate(-50%,-50%);
    -ms-transform:translate(-50%,-50%);
    transform:translate(-50%,-50%);
  }
  .return_goods_take_time_box1{
    width: 520px;
    height: 352px;
    background: #fff;
    position: absolute;
    left: 50%;
    top: 50%;
    -webkit-transform:translate(-50%,-50%);
    -moz-transform:translate(-50%,-50%);
    -o-transform:translate(-50%,-50%);
    -ms-transform:translate(-50%,-50%);
    transform:translate(-50%,-50%);
  }
  .return_goods_take_time_title{
    background:#f3f3f3;
    height: 30px;
    margin-bottom: 20px;
  }
  .return_goods_take_time_title_txt{
    line-height: 30px;
    margin-left: 20px;
    font-weight: 900;
  }
  .return_goods_take_time_item_txt{
    font-size:14px;
    margin-bottom: 10px;
  }
  .return_goods_take_time_title_hide{
    font-size: 20px;
    color:#cdcdcd;
    margin-right: 10px;
    line-height: 30px;
    cursor: pointer;
  }
  .return_goods_take_time_val_txt{
    width: 140px;
    height: 30px;
    text-align: center;
    line-height: 30px;
    background: #f8f8f8;
    margin-bottom: 10px;
    border-radius: 8px;
    margin-right: 30px;
    cursor: pointer;
  }
  .return_goods_take_time_val_txt_active{
    background: #ef4f4f;
    color:#fff;
  }
  .return_goods_take_time_val_txt:last-child{
    margin-right: 0;
  }
  .return_goods_take_address{
    width: 500px;
    height: 180px;
    border: 1px solid #ccc;
    border-radius: 10px;
    padding: 20px;
    overflow-y: auto;
  }
  .return_goods_take_address_item{
    margin-bottom: 15px;
  }
  .return_goods_take_address_item_title{
    width: 100px;
    border: 1px solid #ccc;
    line-height: 20px;
    text-align: center;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    margin-right: 15px;
    cursor: pointer;
  }
  .return_goods_take_address_item_title_active{
    border: 1px solid #ef4f4f;
  }
  .return_goods_take_address_item_txt{
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    width: 360px;
    line-height: 20px;
  }
  .return_goods_take_time_list{
    padding: 0 20px;
  }
  .return_goods_take_time_tips{
    color: #999;
    padding: 10px 20px;
    line-height: 16px;
  }
  .return_goods_take_time_btn{
    padding: 0 20px;
    text-align: center;
  }
  .return_goods_take_time_btn_txt{
    display: inline-block;
    width: 94px;
    height: 35px;
    background: #ef4f4f;
    color: #fff;
    line-height: 35px;
    text-align: center;
    border-radius: 5px;
    margin-right: 20px;
  }
  .return_goods_take_time_btn_txt1{
    margin-right: 0;
    width: 92px;
    height: 33px;
    border:1px solid #ddd;
    background: #f4f4f4;
    color:#666;
  }
</style>



// WEBPACK FOOTER //
// src/components/member/replacement_goods.vue